// extracted by mini-css-extract-plugin
export var active = "LanguageSelector-module--active--855f9";
export var languages = "LanguageSelector-module--languages--1e616";